"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions = exports.types = void 0;
/* eslint-disable default-param-last */
const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";
exports.types = {
    SETUP_HEADER_PROPS: "HEADER/SETUP_HEADER_PROPS",
    /* SEARCHER */
    RESET_SEARCHER: "HEADER/RESET_SEARCHER",
    //JS LOGIC
    SET_SUGGESTED_INPUTS: "HEADER/SET_SUGGESTED_INPUTS",
    GET_RELATED_PAGES: "HEADER/GET_RELATED_PAGES",
    SET_RELATED_PAGES: "HEADER/SET_RELATED_PAGES",
    // APIS
    SET_SEARCH_ENGINE: "HEADER/SET_SEARCH_ENGINE",
    GET_SEARCHER_INFO: "HEADER/GET_SEARCHER_INFO",
    SET_SEARCHER_INFO: "HEADER/SET_SEARCHER_INFO",
};
exports.actions = {
    setupHeaderProps: (data) => ({
        type: exports.types.SETUP_HEADER_PROPS,
        data,
    }),
    /* searcher */
    setSearchEngine: (searchEngine) => ({
        type: exports.types.SET_SEARCH_ENGINE,
        searchEngine,
    }),
    resetSearcher: () => ({ type: exports.types.RESET_SEARCHER }),
    // apis
    getSearcherInfo: () => ({ type: exports.types.GET_SEARCHER_INFO }),
    setSearcherInfo: (info) => ({ type: exports.types.SET_SEARCHER_INFO, info }),
    // js logic
    setSuggestedInputs: (data) => ({ type: exports.types.SET_SUGGESTED_INPUTS, data }),
    getRelatedPages: (query) => ({ type: exports.types.GET_RELATED_PAGES, query }),
    setRelatedPages: (data) => ({ type: exports.types.SET_RELATED_PAGES, data }),
};
const initialState = {
    mainOptions: null,
    navSections: null,
    segmentMenu: null,
    burgerSections: null,
    burgerOptions: null,
    querySuggestedInputs: null,
    inputQuery: "",
    categoriesMatched: null,
    suggestedInputs: null,
    pagesList: null,
    pagesSuggestedList: null,
};
function reducer(state = Object.assign({}, initialState), action) {
    switch (action.type) {
        case HYDRATE: {
            const { header } = action.payload;
            return Object.assign(Object.assign({}, state), header);
        }
        case exports.types.SETUP_HEADER_PROPS: {
            const headerProps = action.data;
            return Object.assign(Object.assign({}, state), headerProps);
        }
        case exports.types.SET_SEARCHER_INFO:
            return Object.assign(Object.assign({}, state), { pagesList: (action.info && action.info.pagesList) || null, querySuggestedInputs: null, suggestedInputs: (action.info && action.info.suggestedInputs) || null, categoryOptions: (action.info && action.info.categoryOptions) || null });
        case exports.types.SET_SUGGESTED_INPUTS: {
            return Object.assign(Object.assign({}, state), { querySuggestedInputs: [...action.data.querySuggestedInputs] });
        }
        case exports.types.RESET_SEARCHER: {
            return Object.assign(Object.assign({}, state), { categoriesMatched: null, querySuggestedInputs: null, pagesSuggestedList: null });
        }
        case exports.types.SET_RELATED_PAGES: {
            return Object.assign(Object.assign({}, state), { inputQuery: action.data.inputQuery, categoriesMatched: action.data.categoriesMatched, pagesSuggestedList: Object.assign({}, action.data.pagesList) });
        }
        default:
            return state;
    }
}
exports.default = reducer;
//# sourceMappingURL=index.js.map